export const SET_ENQUIRY_CONVERT = "SET_ENQUIRY_CONVERT";
export const CLEAR_ENQUIRY_CONVERT = "CLEAR_ENQUIRY_CONVERT";

export const setEnquiryConvert = (data) => ({ type: SET_ENQUIRY_CONVERT, payload: data });
export const clearEnquiryConvert = () => ({ type: CLEAR_ENQUIRY_CONVERT });
